import { SmallButton } from 'mapping/types';
import { IArea, IStateAwareArea } from 'types/map';

export default function createAreaTooltipButtons(
  area: IStateAwareArea,
  currentArea: IArea | undefined,
  onAreaClick?: (_: any, area: IArea) => void,
): SmallButton[] {

  // If this straight up is not an area we can move to, then don't show any buttons
  if (!area.canMoveTo) {
    return [];
  }

  // We can't travel if we don't know how to travel,
  // or if the area's locked
  if (!onAreaClick || !(area.unlocked || area.gateEvent)) {
    return [];
  }

  // We can't travel to where we already are
  if (area.id === currentArea?.id) {
    return [];
  }

  const action = (e: any) => onAreaClick(e, area);
  const label = area.shouldShowGateIcon ? 'Go' : 'Travel';

  return [{ label, action }];
}
